import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { classstyle: "" } },
    [
      _c(VCombobox, {
        attrs: {
          multiple: "",
          dense: "",
          outlined: "",
          chips: "",
          "append-icon": "",
          label: _vm.label,
          placeholder: _vm.computedPlaceholder,
          hint: _vm.computedHint,
          "persistent-hint": "",
          "error-messages": _vm.errors_recipients,
          disabled: _vm.disabled,
          filled: _vm.filled,
          rules: _vm.rules,
          "hide-details": _vm.hide_details ? _vm.hide_details : false,
        },
        on: {
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.addEmail($event)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar",
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.addEmail($event)
            },
          ],
          paste: _vm.onPaste,
          change: _vm.onChangeRecipients,
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function (ref) {
              var item = ref.item
              var attrs = ref.attrs
              var selected = ref.selected
              var disabled = ref.disabled
              var parent = ref.parent
              return [
                _c(
                  VChip,
                  _vm._b(
                    {
                      key: JSON.stringify(item),
                      attrs: {
                        "input-value": selected,
                        disabled: disabled,
                        color: _vm.isValidEmail(item) ? "primary" : "error",
                        dark: "",
                        close: "",
                        small: "",
                      },
                      on: {
                        "click:close": function ($event) {
                          return parent.selectItem(item)
                        },
                      },
                    },
                    "v-chip",
                    attrs,
                    false
                  ),
                  [
                    !_vm.isValidEmail(item)
                      ? _c(VIcon, { attrs: { left: "", small: "" } }, [
                          _vm._v("mdi-alert-circle"),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(item) + " "),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "append-outer",
            fn: function () {
              return [
                _c(
                  VTooltip,
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              VIcon,
                              _vm._g(
                                _vm._b(
                                  { attrs: { small: "", color: "info" } },
                                  "v-icon",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [_vm._v(" mdi-information-outline ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c("div", { staticStyle: { "max-width": "300px" } }, [
                      _c("strong", [_vm._v("Agregar correos:")]),
                      _c("br"),
                      _vm._v(" • Escribe y presiona "),
                      _c("kbd", [_vm._v("Enter")]),
                      _c("br"),
                      _vm._v(" • Escribe y presiona "),
                      _c("kbd", [_vm._v("Espacio")]),
                      _c("br"),
                      _vm._v(
                        " • Separa con comas: email1@domain.com, email2@domain.com"
                      ),
                      _c("br"),
                      _vm._v(" • Pega una lista completa (Ctrl+V / Cmd+V) "),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }